<template>
	<div>
		<div class="row mb-3 px-3">
			<div class="bntGroup">
				<base-button v-if="typeof this.$route.query.client_id !='undefined'" type="primary" simple @click="GoToClient()" class="mr-2"><i class="tim-icons icon-double-left mr-2"></i>К клиенту</base-button>
				<base-button v-if="typeof this.objGetParams.taskend_id != 'undefined'" type="primary" simple @click="showPresentation()" class="mr-2"><i class="tim-icons icon-book-bookmark mr-2"></i>{{strPrezBtnCaption}}<!--span class="ml-2">+10</span--></base-button>
			</div>
		</div>

		<ssoModuleFilter v-if="bIsObjects" @change="OnFilterApply" />
		<!--h6 class="mb-3 text-right">Объектов найдено: {{this.masObjects_total}}</h6-->

		<ReClientNeeds />

		<ReSearchObjects v-if="bIsObjects" :masObjects="ApiData" v-model="dSearchType" @change="OnFilterApply()"/>
		
		<RePresentation v-else :masPresentationObjects="masPresentationObjects.flat_arr"
			:tabChange="validateStep"
		>
			 
			<template v-slot:step1>
				<StpfstFlats
					ref="step1"
					@on-validated="onStepValidated"
					:masPresentationObjects="masPresentationObjects.flat_arr"
				/>				
			</template>
			<template v-slot:step2>
				<StpsndOpts
					ref="step2"
					@on-validated="onStepValidated"
					v-model="masViewOpts"
				/>				
			</template>
			<template v-slot:step3>
				<StptrdSendNew
					ref="step3"
					@on-validated="onStepValidated"
					@sendpres="sendPress"
					:masContacts="masClient[0].contacts"
					:linkText="linkText"
				/>
			</template>
		</RePresentation>
		<Pagination v-if="bIsObjects && (/*typeof $GVO.GetAllGet().dSearchType != 'undefined' &&*/ $GVO.GetAllGet().dSearchType!='complexmap')" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)*parseInt(count2page)" 
			:perPage="parseInt(count2page)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>	
		<!--<Pagination v-if="bIsObjects && (/*typeof $GVO.GetAllGet().dSearchType != 'undefined' &&*/ $GVO.GetAllGet().dSearchType!='complexmap')" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>-->
	</div>
</template>

<script>
	import ReSearchObjects from 'src/our_modules/SearchSendObjects/ReSearchObjects.vue'; 
	import RePresentation from 'src/our_modules/SearchSendObjects/RePresentation.vue';
	import ssoModuleFilter from 'src/our_modules/SearchSendObjects/sso_module_filter.vue';
	import Pagination from 'src/our_components/RePagination';
	import { PageHeader } from 'element-ui';
	import ReClientNeeds from 'src/our_modules/SearchSendObjects/ReClientNeeds.vue';
	import StpfstFlats from 'src/our_modules/SearchSendObjects/PresentationWizard/StpfstFlats.vue';
	import StpsndOpts from 'src/our_modules/SearchSendObjects/PresentationWizard/StpsndOpts.vue';
	import StptrdSendNew from 'src/our_modules/SearchSendObjects/PresentationWizard/StptrdSendNew.vue';


	export default {
		name: 'ssonewbuildings',
		components: {
			ReSearchObjects,
			RePresentation,
			ssoModuleFilter,
			Pagination,
			ReClientNeeds,
			StpfstFlats,
			StpsndOpts,
			StptrdSendNew,			
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ApiData: [],
				bIsObjects: true,
				dSearchType: 'complex',
				masObjects_total: 0,
				count2page: 12,
				objGetParams:{},
				linkText: '',
				masPresentationObjects: {},
				wizardModel: {},
				masViewOpts:[
					{
						elementGetParamMap: 'gk_name',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Название ЖК',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'dev_name',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Название застройщика',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'gk_pass',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Паспорт ЖК',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'b_endingperiod',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Срок сдачи',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'app_floor_image',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Поэтажный план',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'gk_photos',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Фотографии ЖК',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'pano',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Аэропанорама ЖК',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'app_pass',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Паспорт квартиры',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'app_decoration',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Отделка',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'app_image',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Планировка',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'b_keyperiod',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Срок передачи ключей',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'banks',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Банковские программы',
						label_on: 'Да',
						label_off: 'Нет',
					},
					/*{
						elementGetParamMap: 'mortage_calc',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Калькулятор ипотеки',
						label_on: 'Да',
						label_off: 'Нет',
					},*/
					{
						elementGetParamMap: 'anal',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Динамика цен',
						label_on: 'Да',
						label_off: 'Нет',
					},
				],
				masClient: [{contacts:[]}],

			}
		},
		watch: {
			'$route' (to, from) {
				//console.log(to);
				//console.log(from);
				this.getApiData(); // перенёс из OnFilterApply
			}
		},
		computed: {
			strPrezBtnCaption(){
				if(this.bIsObjects)return 'Моя презентация';
				else return 'В поиск';
			}
		},
		methods: {
			makeViewObj(){
				let objRet = {};
				for (let i = 0; i < this.masViewOpts.length; i++) {
					objRet[this.masViewOpts[i].elementGetParamMap] = this.masViewOpts[i].element_model;
				}
				return objRet;
			},			
			onStepValidated(validated, model) {
				this.wizardModel = { ...this.wizardModel, ...model };
			},				
			showPresentation() {
				this.bIsObjects = !this.bIsObjects;	
				if(!this.bIsObjects){
					this.getPresentations();
				}		
			},
			validateStep(ref) {
				
				if(ref == 'step2') this.printPress(); // формируем презентацию
				if(ref == 'step3') this.wizardComplete();
				return this.$refs[ref].validate();
			},
			sendPress(objSend) {
				/*
				this.bIsSendSection = !this.bIsSendSection;
				this.bIsSend = true;
				*/
				if(objSend.strAddr != '' && objSend.strNote != ''){
					this.$GVO.ApiCall('SEND_PRESENTATION',{obj:'presentations',flt:{'path':this.linkText,'cont_type':'mail','cont_value':objSend.strAddr,'mess_text':objSend.strNote}})
					.then((objApi) => {
						if(objApi.success === true){
							//this.linkText = objApi.data.link;
							this.$GVO.showAlert('Презентация','Презентация отправлена','btn btn-success btn-fill');
						}
					}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
				}else{
					alert('адрес или текст сообщения пусто');
				}
			},			
			printPress(){
				let objItogGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('CREATE_PRESENTATION',{obj:'presentations',flt:{'task_id':objItogGetParams.task_id,'taskend_id':objItogGetParams.taskend_id,'client_id':objItogGetParams.client_id}, iData:{...this.makeViewObj()}})
				.then((objApi) => {
					if(objApi.success === true){
						this.linkText = objApi.data.link;
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			},
			wizardComplete() {
				//console.log('В визарде нажали финиш');
				const objGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('RUN_TASK',{obj:'services' ,flt:{'client_id':objGetParams.client_id,'id':objGetParams.task_id,'taskend_id':objGetParams.taskend_id}})
				.then((objApi) => { 
					if(objApi.success === true){
						location.href = '/data/clients/id/'+objGetParams.client_id;
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			},

			getClient(){
				const objGetParams = this.$GVO.GetAllGet();
				if(typeof objGetParams.client_id != 'undefined'){
					this.$GVO.ApiCall('GET',{obj:'client' ,flt:{id:objGetParams.client_id}})
					.then((objApi) => { 
						this.bIsLoading = false;
						//console.log(objApi);
						if(objApi.success === true){
							if(typeof this.$GVO.cats['CONTACTS_TYPES'] == 'undefined'){
								this.$GVO.ApiCall('GET_CONTACTS_TYPES',{obj:"staff"})
									.then((objApiCat) => { 
										//console.log('GET_CONTACTS_TYPES',objApi);
										if(objApiCat.success === true){
											this.$GVO.cats['CONTACTS_TYPES'] = objApiCat.data;
											this.masClient = objApi.data;
										}
									}).catch(errorObjApi => {console.error(errorObjApi);});
							}else{
								this.masClient = objApi.data;
							}
						}
					}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
				}
			},

			getPresentations(){
				let objItogGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('GET',{obj:'presentations',flt:{task_id:objItogGetParams.task_id,taskend_id:objItogGetParams.taskend_id,client_id:objItogGetParams.client_id}})
				.then((objApi) => {
					if(objApi.success === true){
						this.masPresentationObjects = objApi.data;
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			},
			getApiData(){
				this.ApiData = [];
				let filter = {};
				this.objGetParams = this.$GVO.GetAllGet();
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
					filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));				
				}
				this.$GVO.ApiCall('GET',{obj:'NovoObj',flt:{...filter}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
							// if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
							if(objApi.total!=undefined) {this.masObjects_total=objApi.total.countpage;}
						}
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
			},
			OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
				if(strItogGetParams == undefined){
					let objItogGetParams = this.$GVO.GetAllGet();
					if(typeof objItogGetParams.dSearchType !='undefined' && this.dSearchType != objItogGetParams.dSearchType) {
						objItogGetParams.dSearchType = this.dSearchType;
						if(typeof objItogGetParams['p'] != 'undefined'){
							delete objItogGetParams['p'];
						}
					}
					strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
				}
				// console.log('OnFilterApply',strItogGetParams);
				this.$router.push({path: location.pathname+'?'+strItogGetParams});
				//this.getApiData();
			},
			pClick(e){
				let strItogGetParams = '';
				let objItogGetParams = this.$GVO.GetAllGet();
				objItogGetParams.p=parseInt(e);
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
				this.OnFilterApply(strItogGetParams);
			},
			GoToClient(){
				if(typeof this.$route.query.client_id != 'undefined'){
					location.href='/data/clients/id/'+this.$route.query.client_id;
				}
			},
		},
		mounted() {
			var queryParams = new URLSearchParams(window.location.search);
			queryParams.set("dSearchType", "complex");
			history.replaceState(null, null, "?"+queryParams.toString());

			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.objGetParams.show_pres != 'undefined') this.showPresentation();
			if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
			this.getApiData();
			this.getClient();
		}
	}
</script>
<style scoped>
.majorFilter-card {border: 1px solid #01b0e0;}
.majorFilter {display: flex; justify-content: space-between;}
.firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.map-search .btn {margin-top: 0px; width: 207px; padding-left: 5px;}
.allFilters {justify-content: flex-end;}
.allFilters .btn, .applyFilter .btn {margin-top: 0px; margin-right: 15px;}


.ssopage >>> .el-select .el-input.is-focus .el-input__inner:focus {border: 1px solid #01B0E0;}

.map-search >>> .btn.btn-simple {border-color: #2b3553; color: rgba(255, 255, 255, 0.8); font-weight: 400;}
.white-content .map-search >>> .btn.btn-simple {color: #6062667c;}
.map-search >>> .btn.btn-simple:hover {border-color: #01b0e0; color: rgba(1, 176, 224, 0.6); font-weight: 400;}
.ssopage >>> .form-group input:hover, .input-group:hover {border: 1px solid #01b0e0;}

.ssopage >>> .el-select .el-input.is-focus .el-input__inner:hover, .el-input .el-input--large .el-input--suffix:hover {border: 1px solid #01b0e0;}
.ssopage >>> .el-input .el-input--large .el-input--suffix .is-focus {border: 1px solid #01b0e0;}
.ssopage >>> .el-select .el-input.is-focus .el-input__inner  {border: 1px solid #01b0e0;}
.ssopage >>> .el-select__input .is-large:hover > .select-primary.el-select .el-input input {border: 1px solid #01b0e0;}
/*.ReInputSearchDropType:hover {border: 1px solid #01b0e0; border-radius: 6px;}*/
/*.ReInputSearchDropType:hover {margin-bottom: 0; border: 1px solid #01b0e0; border-radius: 6px;}*/

.ssopage >>>  .dropdown-menu .tim-icons {margin-top: -10px;}
.flat-corp-row, .filter-row {display: flex; flex-wrap: wrap;}

.ssopage >>> .outline-secondary {border-right: 1px solid #2b3553}
.ssopage >>> .outline-secondary:hover {border: 1px solid #01B0E0;}
.ssopage >>> .outline-secondary:focus {border-right: 1px solid #01B0E0; border-left: 1px solid #01B0E0;}
.ssopage >>> .flat-corp-row .form-control:hover, .input-group-text:focus {border: none;}
.ssopage >>> .flat-corp-row .input-group:hover {border: 1px solid #01B0E0; border-radius: 6px;}
.ssopage >>> hr {border-top: 1px solid #01B0E0!important;}

.sLabelText label {font-size: .9rem;}
.allFilters .btn {margin-bottom: 10px;}

@media (max-width: 768px) {	
	.map-search, .year-search, .type-search, .price-search, .base-search, .flat-corp-width {margin-right: 0px !important; width: 100%;}
	.map-search .btn.btn-simple {width: 100%;}
}
@media (max-width: 575px) {
	.filter-row > .col-md-4, .filter-row > .col-sm-6 {padding-right: 0px;}
}

.oneline {
	border: 1px solid #9e77f3;
	padding: 10px 15px;
	border-radius: 0.2857rem;
	box-shadow: 0 1px 15px 0 rgba(158, 119, 243, 0.08);
	flex-direction: column;
}
@media (max-width: 768px) {
	.oneline {
		flex-wrap: wrap;
	}
}


</style>
